import { useEffect, useRef, useState } from 'react';

const formatSessionTime = (totalSeconds: number): string => {
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  const pad = (n: number) => String(n).padStart(2, '0');
  return `${pad(hours)}h ${pad(minutes)}m ${pad(seconds)}s`;
};

export const useSessionClock = (isStarted: boolean): string => {
  const startTimeRef = useRef<number | null>(null);
  const [elapsed, setElapsed] = useState(0);

  useEffect(() => {
    if (isStarted && startTimeRef.current === null) {
      startTimeRef.current = Date.now();
    }
  }, [isStarted]);

  useEffect(() => {
    if (!isStarted) return;

    const interval = setInterval(() => {
      if (startTimeRef.current !== null) {
        setElapsed(Math.floor((Date.now() - startTimeRef.current) / 1000));
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [isStarted]);

  return formatSessionTime(elapsed);
};
